import { render, staticRenderFns } from "./FormTranProgramProgramModuleImport.vue?vue&type=template&id=e70f7064&scoped=true"
import script from "./FormTranProgramProgramModuleImport.vue?vue&type=script&lang=js"
export * from "./FormTranProgramProgramModuleImport.vue?vue&type=script&lang=js"
import style0 from "./FormTranProgramProgramModuleImport.vue?vue&type=style&index=0&id=e70f7064&prod&lang=scss&scoped=true"
import style1 from "./FormTranProgramProgramModuleImport.vue?vue&type=style&index=1&id=e70f7064&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e70f7064",
  null
  
)

export default component.exports